/**
 * MODULE: domain/pages/frontend/components/editor/pagesBlockMeta.ts
 * PURPOSE: Stable block id attribute on TipTap nodes for reorder-safe persistence
 */

import { Extension } from '@tiptap/core';

const BLOCK_NODE_TYPES = [
  'paragraph',
  'heading',
  'bulletList',
  'orderedList',
  'blockquote',
  'codeBlock',
  'horizontalRule',
  'pagesImageBlock',
  'pagesFileBlock',
  'pagesPageLinkBlock',
  'pagesBookmarkBlock',
  'pagesActionButtonBlock',
  'pagesDatabaseEmbedBlock',
  'pagesPipelineSnapshotBlock',
  'pagesCrmDealPreviewBlock',
  'pagesCrmContactPreviewBlock',
  'pagesCrmCompanyPreviewBlock',
  'pagesToggleBlock',
  'pagesCalloutBlock',
  'pagesTocBlock',
  'pagesTasksSyncBlock',
  'pagesTranscriptPreviewBlock',
  'pagesTodoBlock',
  'pagesAiBlock',
];

export const PagesBlockMeta = Extension.create({
  name: 'pagesBlockMeta',
  addGlobalAttributes() {
    return [
      {
        types: BLOCK_NODE_TYPES,
        attributes: {
          pagesBlockId: {
            default: null,
            parseHTML: (element) => element.getAttribute('data-pages-block-id'),
            renderHTML: (attributes) => {
              if (!attributes.pagesBlockId) {
                return {};
              }
              return { 'data-pages-block-id': attributes.pagesBlockId };
            },
          },
        },
      },
    ];
  },
});
